<!------------ START TEMPLATE ------------>
<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="exibeModal"
    @close="closeModal"
  >
    <vs-alert
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      Atenção! Ao alterar benefícios em massa, <strong>TODOS</strong> benefícios
      do grupo serão resetados e substituídos pelos benefícios selecionados
      abaixo.
    </vs-alert>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <span ref="mybtn">Cotas</span>
          <v-select
            :options="cotas"
            name="Produto"
            id="Produto"
            v-model="cotasSelected"
            multiple
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-10">
          <span ref="mybtn">Benefícios</span>
          <v-select
            :options="beneficios"
            name="Produto"
            id="Produto"
            v-model="beneficiosSelected"
            multiple
          ></v-select>
        </div>
      </div>

      <div class="flex">
        <!-- tabela de cotas -->
        <div
          class="relative overflow-x-auto shadow-md sm:rounded-lg mr-2"
          style="min-width: 100px; flex-grow: 1"
        >
          <table
            class="w-full text-sm text-left text-gray-500 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
            >
              <tr>
                <th scope="col" class="px-6 py-3">Cota(s)</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in cotasSelected"
                :key="index"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <th
                  scope="row"
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ item.label }}
                </th>

                <td class="px-6 py-4">
                  <a
                    @click="removeCotasSelected(item)"
                    href="#"
                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                    >X</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- tabela de beneficios -->
        <div
          class="relative overflow-x-auto shadow-md sm:rounded-lg"
          style="min-width: 70%; flex-grow: 2"
        >
          <table
            class="w-full text-sm text-left text-gray-500 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
            >
              <tr>
                <th scope="col" class="px-6 py-3">Benefício(s)</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in beneficiosSelected"
                :key="index"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <th
                  scope="row"
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ item.label }}
                </th>

                <td class="px-6 py-4">
                  <a
                    @click="removeBeneficiosSelected(item)"
                    href="#"
                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                    >Remover</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <vs-row>
        <vs-col class="text-right">
          <vs-button color="success" class="mb-2 my-5">
            <span>Alterar</span>
          </vs-button>
        </vs-col>
      </vs-row>
    </form>
  </vs-popup>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import BotaoSubmit from './../../components/BotaoSubmit';
import vSelect from 'vue-select';
import service from '../../services';
import jwt from 'jsonwebtoken';

export default {
  props: ['title', 'dados', 'popupActive', 'grupo'],
  watch: {
    popupActive: function (newValue, oldValue) {
      this.exibeModal = newValue;
    },
    cotasSelected(newValue) {
      if (newValue && newValue.length > 0) {
        if (newValue.find((item) => item.value === 'all')) {
          this.cotasSelected = [];
          this.cotasSelected = this.cotas.filter(
            (item) => item.value !== 'all',
          );
        }
      }
    },
    beneficiosSelected(newValue) {
      if (newValue && newValue.length > 0) {
        if (newValue.find((item) => item.id == 'all')) {
          this.beneficiosSelected = [];
          this.beneficiosSelected = this.beneficios.filter(
            (item) => item.id !== 'all',
          );
        }
      }
    },
  },
  data() {
    return {
      exibeModal: false,
      idTabelaValor: null,
      beneficiosSelected: [],
      cotasSelected: [],
      beneficios: [],
      cotas: [],
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    getBeneficios() {
      this.beneficios = [];
      const token = localStorage.getItem('user-token');
      var idEmpresa = null;
      if (token) {
        const decoded = jwt.decode(token);
        idEmpresa = decoded.id_empresa;
      }
      service.getAll('Beneficios', {}, 'list/' + idEmpresa).then((res) => {
        this.beneficios.push({
          id: 'all',
          label: 'Selecionar Todas',
        });
        res.data.forEach((element) => {
          var tipo = element.Beneficios_domTipoBeneficio.nomeTipo;
          if (element.deletedAt == null) {
            this.beneficios.push({
              id: element.idBeneficio,
              label: tipo + ' - ' + element.nome,
            });
          }
        });
      });
    },
    getCotas() {
      this.$vs.loading();
      service
        .getAll('TabelaValores', {}, 'list/' + this.$route.params.id)
        .then((res) => {
          this.cotas = [];
          this.cotas.push({
            idTabelaValor: null,
            label: 'Selecionar Todas',
            value: 'all',
          });
          res.data.forEach((element) => {
            this.cotas.push({
              idTabelaValor: element.idTabelaValor,
              label: element.cota,
              value: element.idTabelaValor,
            });
          });
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    onSubmit() {
      this.$vs.loading();
      var data = {
        idTabelaValor: this.$route.params.id,
        idBeneficios: this.beneficiosSelected,
        idCotas: this.cotasSelected,
      };
      service
        .post('TabelaValoresBeneficios', 'AtualizarEmMassa', data)
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Sucesso',
            text: 'Benefícios adicionados com sucesso!',
            color: 'success',
          });
          this.beneficiosSelected = [];
          this.beneficiosSelected = [];
          this.closeModal();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    removeBeneficiosSelected(item) {
      this.beneficiosSelected.splice(this.beneficiosSelected.indexOf(item), 1);
    },
    removeCotasSelected(item) {
      this.cotasSelected.splice(this.cotasSelected.indexOf(item), 1);
    },
  },
  mounted() {
    this.getBeneficios();
    this.getCotas();
  },
  components: {
    BotaoSubmit,
    vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.con-vs-popup .vs-popup {
  width: 100% !important;
}
</style>
